import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Moment from 'moment';
import { ImInfo } from 'react-icons/im';
import ReactTooltip from 'react-tooltip';
import Button from '../../components/button/button';
import FrequencyPicker from '../../components/frequencypicker/frequencypicker';
import CurrencyInput from '../../components/currencyinput/currencyinput';
import DatePicker from '../../components/datepicker/datepicker';
import { QUESTIONS } from '../../constants.jsx';
import HeaderTable from '../../components/headertable/headertable';

function Question4(props) {
  const {
    onFinish,
    onBack,
    incurredDate: [incurredDate],
    incurredAmount: [incurredAmount],
    paymentFrequency: [paymentFrequency, setPaymentFrequency],
    paymentFrequencyAmount: [paymentFrequencyAmount, setPaymentFrequencyAmount],
    paymentFrequencyStartDate: [
      paymentFrequencyStartDate,
      setPaymentFrequencyStartDate,
    ],
  } = {
    ...props,
  };

  const [dateErrorMessage, setDateErrorMessage] = useState();
  const [amountErrorMessage, setAmountErrorMessage] = useState();
  const [frequencyErrorMessage, setFrequencyErrorMessage] = useState();

  const validateDate = newDate => {
    let valid = true;
    setDateErrorMessage('');

    if (newDate === null || newDate === undefined) {
      setDateErrorMessage('Debt date must be set');
      valid = false;
    }

    return valid;
  };

  const validateAmount = newAmount => {
    let valid = true;
    setAmountErrorMessage('');

    if (
      newAmount === null ||
      newAmount === undefined ||
      Number.isNaN(newAmount) ||
      newAmount === ''
    ) {
      setAmountErrorMessage('Amount must be set');
      valid = false;
    }
    if (newAmount === '0.00' || newAmount === 0) {
      setAmountErrorMessage('Amount must be greater than 0');
      valid = false;
    }
    return valid;
  };

  const validateFrequency = newFrequency => {
    setFrequencyErrorMessage('');
    if (newFrequency) {
      return true;
    }
    setFrequencyErrorMessage('Please select a frequency');
    return false;
  };

  const questionValidation = () => {
    const vf = validateFrequency(paymentFrequency);
    const va = validateAmount(paymentFrequencyAmount);
    const vd = validateDate(paymentFrequencyStartDate);
    if (vf && va && vd) {
      return true;
    }
    return false;
  };

  const onFrequencyChange = newFrequency => {
    validateFrequency(newFrequency);
    setPaymentFrequency(newFrequency);
  };

  const onDateChange = newDate => {
    validateDate(newDate);
    setPaymentFrequencyStartDate(newDate);
  };

  const onAmountChange = newAmount => {
    validateAmount(newAmount);
    setPaymentFrequencyAmount(newAmount);
  };

  let today = new Moment();
  const maxFirstPaymentDate = new Moment(today).add(5, 'years').toDate();
  today = today.toDate();

  return (
    <>
      <h3>
        {QUESTIONS.QUESTION5}
        <a data-event="click" type="submit" data-tip data-for="tooltip1">
          <ImInfo className="help-text-button" />
        </a>
      </h3>

      <ReactTooltip
        globalEventOn="click"
        globalEventOff="click"
        id="tooltip1"
        place="bottom"
        effect="solid"
      >
        <div>Q4 help text needed</div>
      </ReactTooltip>

      <HeaderTable date={incurredDate} amount={incurredAmount} />
      <br />

      <Row>
        <FrequencyPicker
          title="Payment frequency*"
          value={paymentFrequency}
          onValueChange={onFrequencyChange}
          placeHolder="Select frequency"
          errorMessage={frequencyErrorMessage}
          className="full-size"
        />
      </Row>
      <Row>
        <CurrencyInput
          title="Payment amount*"
          value={paymentFrequencyAmount}
          onValueChange={onAmountChange}
          errorMessage={amountErrorMessage}
        />
      </Row>
      <Row>
        <br />
        <DatePicker
          title="First payment date*"
          date={paymentFrequencyStartDate}
          minDate={today}
          maxDate={maxFirstPaymentDate}
          onDateChange={onDateChange}
          errorMessage={dateErrorMessage}
        />
      </Row>

      <Row className="button-wrapper">
        <Col className="no-margin">
          <Button title="Back" variant="secondary" onClick={onBack} />

          <Button
            title="Next"
            variant="primary"
            onClick={() => {
              if (questionValidation()) {
                onFinish({
                  paymentFrequency,
                  paymentFrequencyAmount,
                  paymentFrequencyStartDate,
                });
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
}

export default Question4;
